import { useMemo, useState, React, useEffect, useRef, useCallback } from 'react';
import { Easing } from 'react-native-web';
import { createAlchemyWeb3 } from "@alch/alchemy-web3";
import * as encryptUtils from "./encryptDecryptUtils";
import * as dateUtils from "./utils/dateUtils";
import * as loggingUtils from "./utils/loggingUtils";
import * as scriptUtils from './utils/scriptUtils';
import ChatChannelMessage from './ChatChannelMessage';
import WidgetBot from '@widgetbot/react-embed';
import Fly from 'react-flying-objects';
import { FaSmile } from "react-icons/fa";
import { FaCheck } from "react-icons/fa";
import Picker from 'emoji-picker-react';
import './ChatChannel.css';
import ChatChannelTopBar from './ChatChannelTopBar';
import ChatUserInformationModal from './ChatUserInformationModal';
import API, { graphqlOperation  } from "@aws-amplify/api-graphql";
import * as mutations from './graphql/mutations';
import * as subscriptions from './graphql/subscriptions';
import * as queries from './graphql/queries';

const DELAY = 1000;
const DURATION = 5000;
const SIZE = 25;

const {
  REACT_APP_ETHEREUM_API_URL,
} = process.env;

let web3 = createAlchemyWeb3(REACT_APP_ETHEREUM_API_URL);
let abiFor721 = require("./artifacts/contracts/Zora721.sol/Zora721.json");
let jsonFor1155 = require("./artifacts/contracts/BondingCurveNFT.sol/BondingCurveNFT.json");
let abiFor1155 = jsonFor1155.abi;

const composerHeightLimit = 270;

const random = (min, max) => Math.floor(Math.random() * (max - min) + min)

const wsURL = "wss://41diloqf5a.execute-api.us-west-2.amazonaws.com/dev";

const ChatAndFlyingObjects = (props) => {
  const socket = useRef(null);
  const textInput = useRef(null);
  const [animatedImage, setAnimatedImage] = useState() // To randomly set values in the objectConfig
  const [flyingObjects, setFlyingObjects] = useState([]) // Used to manage all flying currently objects by the Fly component
  const [balances, setBalances] = useState([0, 0, 0]);
  const [emojiPickerActive, setEmojiPickerActive] = useState(false);
  const [isInUserProfileFlow, setIsInUserProfileFlow] = useState(false);

  const contracts = props.emotes.map(emoteInfo => {
    if(emoteInfo.length === 1) {
      return null;
    } else if(emoteInfo.length === 3) {
      return new web3.eth.Contract(abiFor721, emoteInfo[1]);
    } else {
      return new web3.eth.Contract(abiFor1155, emoteInfo[1]);
    }
  });

  const onKeyDown = async e => {
    if(e.keyCode === 13 && e.shiftKey == false) {
      // Pressed enter
      e.preventDefault();
      if (/\S/.test(props.currentMessage)) {
        // Only send if string has something other than spaces and new lines
        let newMessage = {};
        newMessage['message'] = props.currentMessage;
        newMessage['profileImage'] = props.userInfo.pfp;
        newMessage['name'] = props.userInfo.username;
        let date = new Date();
        newMessage['timestamp'] = date.getTime();
        newMessage['time'] = dateUtils.convertDateTime(date);
        newMessage['badgeInfo'] = props.badgeInfo;
        newMessage['isNFTPFP'] = props.userInfo.isNFTPFP;
        sendMessage(newMessage);
        loggingUtils.logEvent(
          props.address != null
            ? props.address
            : encryptUtils.getWalletUnconnectedUserId(),
          "livestream_chat",
          "livestream_chat_send_message",
          "info",
          "https://the402.xyz",
          {}
        );
        let splitMessage = props.currentMessage.split(" ");
        if(splitMessage.length >= 2 && splitMessage[0].toLowerCase() === "pay" && !isNaN(splitMessage[1])) {
          let didPay = await props.payStreamer(splitMessage[1]);
          if(didPay) {
            newMessage = {};
            newMessage['message'] = props.userInfo.username + " just sent " + splitMessage[1] + " ETH to " + props.creatorName;
            newMessage['profileImage'] = "https://pbs.twimg.com/profile_images/1521659343309086720/2Lle15fa_400x400.png";
            newMessage['name'] = "the402";
            date = new Date();
            newMessage['timestamp'] = date.getTime();
            newMessage['time'] = dateUtils.convertDateTime(date);
            newMessage['badgeInfo'] = {};
            newMessage['isNFTPFP'] = false;
            sendMessage(newMessage);
            // props.triggerAnimation();
          }
        } else if(splitMessage.length >= 1 && splitMessage[0].toLowerCase() === "pay") {
          let didPay = await props.payStreamer("0.01");
          if(didPay) {
            newMessage = {};
            newMessage['message'] = props.userInfo.username + " just sent 0.01 ETH to " + props.creatorName;
            newMessage['profileImage'] = "https://pbs.twimg.com/profile_images/1521659343309086720/2Lle15fa_400x400.png";
            newMessage['name'] = "the402";
            date = new Date();
            newMessage['timestamp'] = date.getTime();
            newMessage['time'] = dateUtils.convertDateTime(date);
            newMessage['badgeInfo'] = {};
            newMessage['isNFTPFP'] = false;
            sendMessage(newMessage);
            // props.triggerAnimation();
          }
        } else if(props.currentMessage.trim().toLowerCase() === "mint") {
          let didMint = await props.mintFromChat();
          if(didMint) {
            newMessage = {};
            newMessage['message'] = props.userInfo.username + " just minted " + props.nftSalesLivestream.item;
            newMessage['profileImage'] = "https://pbs.twimg.com/profile_images/1521659343309086720/2Lle15fa_400x400.png";
            newMessage['name'] = "the402";
            date = new Date();
            newMessage['timestamp'] = date.getTime();
            newMessage['time'] = dateUtils.convertDateTime(date);
            newMessage['badgeInfo'] = {};
            newMessage['isNFTPFP'] = false;
            sendMessage(newMessage);
            // props.triggerAnimation();
          }
        }
      }
      props.updateCurrentMessage('');
      if(textInput.current != null) {
        textInput.current.style.cssText = "";
        textInput.current.parentElement.style.cssText = "";
      }
    }
    // Set text area to grow if necessary
    if(textInput.current != null) {
      let newHeight = Math.min(e.target.scrollHeight, composerHeightLimit);
      textInput.current.style.cssText = 'height: ' + newHeight.toString() + 'px ';
      textInput.current.parentElement.style.cssText = 'height: ' + newHeight.toString() + 'px ';
    }
  };

  const onSocketOpen = useCallback(() => {
    socket.current.send(JSON.stringify({
      action: 'requestUserList',
      sender: props.address,
      creatorAddress: props.creatorAddress,
    }));
  }, []);

  const onSocketMessage = useCallback((data) => {
    data = JSON.parse(data);
    let message = data.message;
    let sender = data.sender;
    if(message === "User List") {
      let users = data.users;
      props.setAddresses(users);
    } else if(message === "Joined") {
      props.addAddress(sender);
    } else if(message === "Left") {
      props.removeAddress(sender);
    }
  }, []);

  const isMessageEmote = (message) => {
    for(let i = 0; i < props.emotes.length; i++) {
      if(props.emotes[i][0] === message) {
        return true;
      }
    }
    return false;
  }

  const onSocketMessageEmotes = useCallback((data) => {
    data = JSON.parse(data);
    let message = data.message;
    let sender = data.sender.toLowerCase();
    if(isMessageEmote(message)) {
      let image = <img src={message.replaceAll('"', '')} />
      setAnimatedImage(image);
      props.setAnimatedImageForUser(sender, message.replaceAll('"', ''));
    }
  }, []);

  const onSocketMessageChat = useCallback((data) => {
    data = JSON.parse(data);
    let message = data.message;
    let sender = data.sender.toLowerCase();
    if(
      !isMessageEmote(message) &&
      message !== "User List" &&
      message !== "Joined" &&
      message !== "Left"
    ) {
      props.addMessage(message);
    }
  }, []);

  useEffect(() => {
    const initializeSocket = async () => {
      const subscription = API.graphql(
        graphqlOperation(subscriptions.messageSent, {
          roomId: props.creatorAddress.toLowerCase()
        })
      ).subscribe({
        next: ({ provider, value }) => props.addSubscribedMessage(value),
        error: (error) => console.warn(error)
      });
      const ens = await encryptUtils.getENS(props.address.toLowerCase());
      props.setENS(ens);
      if(socket.current == null || socket.current.readyState !== WebSocket.OPEN) {
        socket.current = new WebSocket(wsURL + "/?address=" + ens + "&creatorAddress=" + props.creatorAddress.toLowerCase());
        console.log("Adding emotes event listeners");
        socket.current.addEventListener('message', (event) => {
          onSocketMessage(event.data);
        });
        socket.current.addEventListener('message', (event) => {
          onSocketMessageEmotes(event.data);
        });
        socket.current.addEventListener('message', (event) => {
          onSocketMessageChat(event.data);
        });
        socket.current.addEventListener('open', onSocketOpen);
      }
    }
    initializeSocket();
    if(textInput.current != null) {
      console.log("Adding chat event listener");
      textInput.current.focus();
    }
    getBalances();
    getMessages();
    return () => {};
  }, []);

  const onSelect = url => {
    if(socket.current != null) {
      loggingUtils.logEvent(
        props.address != null
          ? props.address
          : encryptUtils.getWalletUnconnectedUserId(),
        "emotes",
        "emotes_click_emote",
        "info",
        "https://the402.xyz",
        {
          url: url,
        }
      );
      socket.current.send(JSON.stringify({
        action: 'sendMessage',
        message: url,
        sender: props.ens,
        creatorAddress: props.creatorAddress
      }));
    }
  }

  const onEmojiClick = (_event, emojiObject) => {
    if(Object.keys(props.userInfo).length === 0) {
      setIsInUserProfileFlow(true);
      return;
    }
    let newCurrentMessage = props.currentMessage + emojiObject["emoji"];
    props.updateCurrentMessage(newCurrentMessage);
  }

  const handleTextChange = (e) => {
    if(Object.keys(props.userInfo).length === 0) {
      setIsInUserProfileFlow(true);
      return;
    }
    props.updateCurrentMessage(e.target.value);
    // Set text area to grow if necessary
    if(textInput.current != null) {
      let newHeight = Math.min(e.target.scrollHeight, composerHeightLimit);
      textInput.current.style.cssText = 'height: ' + newHeight.toString() + 'px';
      textInput.current.parentElement.style.cssText = 'height: ' + newHeight.toString() + 'px';
    }
  }

  const onComposerClick = () => {
    if(Object.keys(props.userInfo).length === 0) {
      setIsInUserProfileFlow(true);
      return;
    }
    // Focus composer, blur active element, and hide emoji keyboard
    if(textInput.current != null) {
      textInput.current.focus();
    }
    setEmojiPickerActive(false);
  }

  const onComposerDoubleClick = () => {
    if(Object.keys(props.userInfo).length === 0) {
      setIsInUserProfileFlow(true);
      return;
    }
    // Select all text and hide emoji keyboard
    if(textInput.current != null) {
      textInput.current.setSelectionRange(0, props.currentMessage.length);
    }
    setEmojiPickerActive(false);
  }

  const toggleEmojiPicker = () => {
    if(Object.keys(props.userInfo).length === 0) {
      setIsInUserProfileFlow(true);
      return;
    }
    setEmojiPickerActive(!emojiPickerActive);
  }

  const objectConfig = useMemo(() => ({ // Config for a single flying object which would fly in a moment
    right: {
      fromValue: 250,
      toValue: 900,
      duration: DURATION,
      delay: DELAY,
    },
    top: {
      fromValue: random(0, 0),
      toValue: random(-300, -200),
      duration: DURATION,
      easing: Easing.elastic(5),
      delay: DELAY,
    },
    width: {
      fromValue: random(SIZE - 10, SIZE + 10),
      toValue: SIZE,
      duration: DURATION,
      easing: Easing.elastic(5),
      delay: DELAY,
    },
    height: {
      fromValue: random(SIZE - 10, SIZE + 10),
      toValue: SIZE,
      duration: DURATION,
      easing: Easing.elastic(5),
      delay: DELAY,
    },
    opacity: {
      fromValue: 1,
      toValue: 0,
      duration: DURATION,
      easing: Easing.exp,
      delay: DELAY,
    }
  }), [animatedImage]) // On animatedImage change we calculate new random values for the next flying object

  const sendMessage = async (newMessage) => {
    let sentMessage = await API.graphql({
      query: mutations.sendMessage,
      variables: {
        roomId: props.creatorAddress.toLowerCase(),
        text: newMessage['message'],
        info: JSON.stringify(newMessage)
      }
    })
  }

  const getMessages = async () => {
    let messageInfo = await API.graphql({
      query: queries.getMessages,
      variables: {
        roomId: props.creatorAddress.toLowerCase()
      },
      authMode: 'API_KEY'
    });
    props.setMessageInfo(messageInfo);
  }

  const isTop = (el) => {
    // Means all the way scrolled up
    return (el.scrollHeight + el.scrollTop) <= el.getBoundingClientRect().height;
  }

  const trackScrolling = async () => {
    const wrappedElement = document.getElementById('hypeshot-chatChannelMessagesWrapper');
    if (isTop(wrappedElement)) {
      document.removeEventListener('scroll', trackScrolling);
      let scrollPosition = wrappedElement.scrollTop;
      await getOlderMessages();
      wrappedElement.scrollTop = scrollPosition;
      document.addEventListener('scroll', trackScrolling);
    }
  }

  const getOlderMessages = async () => {
    if(props.nextToken == null) {
      return;
    }
    let messageInfo = await API.graphql({
      query: queries.getMessages,
      variables: {roomId: props.creatorAddress.toLowerCase(), nextToken: props.nextToken},
      authMode: 'API_KEY'
    });
    props.addPaginatedMessages(messageInfo);
  }

  const getBalances = async () => {
    let calculatedBalances = await Promise.all(props.emotes.map(async (emoteInfo, ind) => {
      if(emoteInfo.length === 1) {
        return 1;
      } else if(emoteInfo.length === 3) {
        return await contracts[ind].methods.balanceOf(props.address).call();
      } else {
        return await contracts[ind].methods.balanceOf(props.address, emoteInfo[3]).call();
      }
    }));
    setBalances(calculatedBalances);
  };

  const purchaseItem = async (info, balances, ind) => {
    loggingUtils.logEvent(
      props.address != null
        ? props.address
        : encryptUtils.getWalletUnconnectedUserId(),
      "emotes",
      "emotes_purchase_item",
      "info",
      "https://the402.xyz",
      {}
    );
    let contractAddress = info[0];
    let price = info[2];
    let balancesCopy = [...balances];
    props.setTransactionStatus("Pending");
    if(info.length === 3) {
      let didApprove = await encryptUtils.buyZora721Emote(
        props.address,
        contractAddress,
        price
      );
      if(didApprove) {
        loggingUtils.logEvent(
          props.address != null
            ? props.address
            : encryptUtils.getWalletUnconnectedUserId(),
          "external_purchases",
          "external_purchase",
          "info",
          "https://the402.xyz",
          {
            "type": "zora721",
            "price": price,
            "contractAddress": contractAddress
          }
        );
        props.setTransactionStatus("Purchase Complete");
        balancesCopy[ind] += 1;
        setBalances(balancesCopy);
      } else {
        props.setTransactionStatus("None");
      }
    } else {
      let tokenId = info[3];
      let didApprove = await encryptUtils.buyManifold1155Emote(
        props.address,
        contractAddress,
        price,
        tokenId
      );
      if(didApprove) {
        loggingUtils.logEvent(
          props.address != null
            ? props.address
            : encryptUtils.getWalletUnconnectedUserId(),
          "external_purchases",
          "external_purchase",
          "info",
          "https://the402.xyz",
          {
            "type": "manifold1155",
            "price": price,
            "contractAddress": contractAddress
          }
        );
        props.setTransactionStatus("Purchase Complete");
        balancesCopy[ind] += 1;
        setBalances(balancesCopy);
      } else {
        props.setTransactionStatus("None");
      }
    }
  }

  let messageContent = props.messages.map(messageInfo => {
    let info = JSON.parse(messageInfo["info"]);
    let message = messageInfo["text"];
    return (
      <ChatChannelMessage
        username={props.userInfo != null ? props.userInfo.username : null}
        messageInfo={info}
        message={message}
        key={info["name"] + info["timestamp"]}
      />
    );
  });

  return (
    <div className="bg-custom-black sm:flex-col sm:flex flex flex-col-reverse">
      { /* <WidgetBot className="w-screen md:w-[300px] h-screen mt-0 h-[600px] md:h-[calc(100vh-108px)]"
        server="961416721405714443"
        channel="1039186370977071114"
        shard="https://e-the402.widgetbot.co"
      /> */ }
      <ChatChannelTopBar
        creatorName={props.creatorName}
        setIsInUserProfileFlow={setIsInUserProfileFlow}
      />
      {
        isInUserProfileFlow
          ?
        <ChatUserInformationModal
          address={props.address != null ? props.address.toLowerCase() : encryptUtils.getWalletUnconnectedUserId()}
          updateUserInfo={(userInfo) => {
            props.updateUserInfo(userInfo);
            setIsInUserProfileFlow(false);
          }}
          setIsInUserProfileFlow={setIsInUserProfileFlow}
          userOwnedNFTs={props.userOwnedNFTs}
        />
          :
        null
      }
      <div className = "w-screen flex flex-col justify-end md:w-[300px] h-screen mt-0 h-[600px] md:h-[calc(100vh-156px)]">
        <div className="bg-custom-black flex flex-col justify-end md:max-h-[calc(100vh-156px)] overflow-scroll scrollbar-hide">
          <div
            className="flex flex-col-reverse md:w-[300px] overflow-auto scrollbar-hide"
            id="hypeshot-chatChannelMessagesWrapper"
            onScroll={trackScrolling}
          >
            <div>
              {messageContent}
            </div>
          </div>
        </div>
        {
          emojiPickerActive
            ?
          <Picker
            onEmojiClick={onEmojiClick}
            pickerStyle={{
              position: 'absolute',
              bottom: '96px',
              right: '12px',
              height: '280px',
              width: '280px',
            }}
          />
            :
          null
        }
        <div className="hypeshot-chatChannelMessageComposer">
          <textarea
            onChange={handleTextChange}
            onClick={onComposerClick}
            onDoubleClick={onComposerDoubleClick}
            onKeyDown={onKeyDown}
            className={
              props.userInfo == null || Object.keys(props.userInfo).length === 0
                ?
              "cursor-pointer hypeshot-chatChannelCurrentMessage"
                :
              props.currentMessage === ''
                ?
              "hypeshot-chatChannelCurrentMessage"
                :
              "hypeshot-chatChannelCurrentMessageWithText"
            }
            placeholder={
              props.userInfo == null || Object.keys(props.userInfo).length === 0
                ?
              "Click to login and chat"
                :
              "Send a message"
            }
            ref={textInput}
            value={props.currentMessage}
          />
          <div className={
            emojiPickerActive
              ?
            "hypeshot-chatChannelEmojiEntryActive"
              :
            "hypeshot-chatChannelEmojiEntry"
          }>
            <FaSmile onClick={toggleEmojiPicker} size={22} />
          </div>
        </div>
      </div>
      <div className="flyingobjectsContainer">
        <div>
          {
            animatedImage != null
              ?
            <Fly
              objectToFly={animatedImage}
              objectConfig={objectConfig}
              flyingObjects={flyingObjects}
              setFlyingObjects={setFlyingObjects}
            />
              :
            null
          }
          <div className="flex w-full mt-2 mb-2 justify-center">
            {
              props.emotes.map((emoteInfo, ind) => {
                return (
                  <button
                    key={ind}
                    className="mx-2"
                    onClick={() => {
                      if(balances[ind] > 0) {
                        onSelect(emoteInfo[0]);
                      }
                    }}
                  >
                    <img className="w-[28px] h-[28px]" src={emoteInfo[0]} />
                    {
                      balances[ind] === 0
                        ?
                      <div>
                        <div
                          className="cursor-pointer w-14 hover:-translate-y-0 hover:scale-105 duration-500 font-semibold mt-2 bg-blue-500 text-white rounded-md"
                          onClick={async () => await purchaseItem(emoteInfo, balances, ind)}
                        >
                          {
                            emoteInfo[2] > 0
                              ?
                            "Buy"
                              :
                            "Claim"
                          }
                        </div>
                        {
                          emoteInfo[2] === 0
                            ?
                          <div className="text-gray-500 h-4 text-xs dark:text-gray-400">
                            FREE
                          </div>
                            :
                          null
                        }
                      </div>
                        :
                      emoteInfo.length > 1
                        ?
                      <div>
                        <div className="w-14 rounded-md text-white bg-yellow-500 mt-2 h-6 flex justify-center items-center">
                          <FaCheck size={16} />
                        </div>
                        <div className="text-gray-500 h-4 text-xs dark:text-gray-400">
                        </div>
                      </div>
                        :
                      null
                    }
                  </button>
                );
              })
            }
          </div>
        </div>
      </div>
    </div>
  )
}

export default ChatAndFlyingObjects;
